export default {
  "Invitation details": "Invitation details",
  "This member cannot sign in until they have chosen their password from the invitation email. Their permissions can be edited in the meantime.": "This member cannot sign in until they have chosen their password from the invitation email. Their permissions can be edited in the meantime.",
  "Sending the invitation again issues a new link and invalidates the previous one.": "Sending the invitation again issues a new link and invalidates the previous one.",
  "Invited by": "Invited by",
  "Sent on": "Sent on",
  "Expires on": "Expires on",
  "Expired on": "Expired on",
  "Only the email address is required. They will confirm their details and choose their own password from the invitation email.": "Only the email address is required. They will confirm their details and choose their own password from the invitation email.",
  "No user account found for this email. Invite this person to add them as a team member.": "No user account found for this email. Invite this person to add them as a team member.",
  "Invite this person": "Invite this person",
  "Send the invitation": "Send the invitation",
  "Pending invitation": "Pending invitation",
  "Invitation expired": "Invitation expired",
  "Resend the invitation": "Resend the invitation",
  "The invitation has been sent again.": "The invitation has been sent again.",
  "The invitation could not be sent again.": "The invitation could not be sent again.",
  "No event departs from your general preferences.": "No event departs from your general preferences.",
  "Remove this exception": "Remove this exception",
  "Set a preference for this event": "Set a preference for this event",
  "Follow my general preference": "Follow my general preference",
  "Default": "Default",
  "Notification preference saved": "Notification preference saved",
  "Exceptions by event": "Exceptions by event",
  "These events do not follow your general preferences. Removing an exception puts the event back in line with them.": "These events do not follow your general preferences. Removing an exception puts the event back in line with them.",
  "Unknown event": "Unknown event",
  "Receive": "Receive",
  "Do not receive": "Do not receive",
  "No barcode order": "No barcode order",
  "barcodes_count": "1 barcode | {count} barcodes",
  "{count} barcodes assigned out of {requested} requested": "{count} barcodes assigned out of {requested} requested",
  "Barcodes": "Barcodes",
  "real": "real",
  "auto": "auto",
  "without": "without",
  "No item in an event park": "No item in an event park",
  "Customize": "Customize",
  "Collapse": "Collapse",
  "Preset": "Preset",
  "Basic": "Basic",
  "Advanced": "Advanced",
  "Full": "Full",
  "Choose columns to export": "Choose columns to export",
  "{count} columns selected": "{count} columns selected",
  "Loading...": "Loading...",
  "An error occurred": "An error occurred",
  "Model Id": "Model Id",
  "Model reference": "Model reference",
  "Model year": "Model year",
  "Item Id": "Item Id",
  "Item barcode": "Item barcode",
  "Item size": "Item size",
  "Item color": "Item color",
  "Item serial number": "Item serial number",
  "Item reference": "Item reference",
  "Nbr of tests": "Nbr of tests",
  "Current test event": "Current test event",
  "Current test start date": "Current test start date",
  "Current test end date": "Current test end date",
  "Current tester name": "Current tester name",
  "Current allotment start date": "Current allotment start date",
  "Current allotment end date": "Current allotment end date",
  "Current allotment status": "Current allotment status",
  "Current allotment title": "Current allotment title",
  "Current allotment description": "Current allotment description",
  "A confirmation code has just been sent to you by message": "A confirmation code has just been sent to you by message",
  "Already have an account": "Already have an account",
  "Beyond this time, the reservation we retain will be available again for others": "Beyond this time, the reservation we retain will be available again for others",
  "Book now": "Book now",
  "Booking": "Booking",
  "Booking information": "Booking information",
  "Booking start the first day at {startTime} and finish the last day at {endTime}": "Booking start the first day at {startTime} and finish the last day at {endTime}",
  "Cancel booking": "Cancel booking",
  "An error occurred while processing your booking.": "An error occurred while processing your booking.",
  "Choose your date": "Choose your date",
  "Click to interact with the map": "Click to interact with the map",
  "Confirm my phone number": "Confirm my phone number",
  "Confirm my registration": "Confirm my registration",
  "Confirm my registration and pay": "Confirm my registration and pay",
  "Continue as guest": "Continue as guest",
  "Continue to registration": "Continue to registration",
  "Color": "Color",
  "Color:": "Color:",
  "Create an account": "Create an account",
  "Dates": "Dates",
  "at {date}": "at {date}",
  "Not Synchronized": "Not Synchronized",
  "Synchronizing…": "Synchronizing…",
  "Synchronization in progress…": "Synchronization in progress…",
  "Synchronize now": "Synchronize now",
  "Synchronized": "Synchronized",
  "Loading synchronization status…": "Loading synchronization status…",
  "Waiting for server to complete synchronization…": "Waiting for server to complete synchronization…",
  "View response details": "View response details",
  "No synchronization status available.": "No synchronization status available.",
  "End Date of Reservation": "End Date of Reservation",
  "Enlarge map": "Enlarge map",
  "Enter your code here to confirm your registration": "Enter your code here to confirm your registration",
  "I accept the Terms and conditions of registration": "I accept the Terms and conditions of registration",
  "I accept the terms of service and confirm that I have read the privacy policy": "I accept the terms of service and confirm that I have read the privacy policy",
  "Loading…": "Loading…",
  "Location": "Location",
  "New location": "New location",
  "Address": "Address",
  "Additional information": "Additional information",
  "More information": "More information",
  "No slots available": "No slots available",
  "Processing booking…": "Processing booking…",
  "Processing payment…": "Processing payment…",
  "Product": "Product",
  "Recording payment…": "Recording payment…",
  "Reduce map": "Reduce map",
  "Remaining time": "Remaining time",
  "Required fields": "Required fields",
  "Reserving a product is mandatory for registration": "Reserving a product is mandatory for registration",
  "Retrieving available slots": "Retrieving available slots",
  "Saving registration…": "Saving registration…",
  "Select size first": "Select size first",
  "Select stage first": "Select stage first",
  "Select your options and dates to book": "Select your options and dates to book",
  "Size": "Size",
  "Slot": "Slot",
  "Stage": "Stage",
  "Store": "Store",
  "Calendar": "Calendar",
  "Events": "Events",
  "From: {date}": "From: {date}",
  "To: {date}": "To: {date}",
  "Start at:": "Start at:",
  "End at:": "End at:",
  "Select booking dates": "Select booking dates",
  "numberOfDays": "0 day | 1 day | {d} days",
  "Start Date of Reservation": "Start Date of Reservation",
  "View privacy policy": "View privacy policy",
  "View terms and conditions": "View terms and conditions",
  "You do not want to create an account": "You do not want to create an account",
  "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.": "The selected product has been set aside for you. You have {minutes} minutes to complete the process by providing your personal information.",
  "Your reservation is in progress!": "Your reservation is in progress!",
  "not available": "not available",
  "remaining place": "remaining place",
  "see availability": "see availability",
  "Size available": "Size available | Sizes available",
  "park": "park | parks",
  "Manage": "Manage",
  "Model": "Model",
  "Models": "Models",
  "Model name": "Model name",
  "Item": "Item",
  "Items": "Items",
  "Items list": "Items list",
  "Detach": "Detach",
  "Validated": "Validated",
  "Awaiting acceptance": "Awaiting acceptance",
  "Products": "Products",
  "Parks linked": "Parks linked",
  "No brands for this exhibitor yet.": "No brands for this exhibitor yet.",
  "Catalog details will appear once the exhibitor accepts the invitation.": "Catalog details will appear once the exhibitor accepts the invitation.",
  "click to select": "click to select",
  "Parks configuration for {tour}": "Parks configuration for {tour}",
  "The park for this event is defined by the organizer and applied automatically. There is no park to select, but you still need to add your items to the event park to make them available.": "The park for this event is defined by the organizer and applied automatically. There is no park to select, but you still need to add your items to the event park to make them available. | The parks for this event are defined by the organizer and applied automatically. There are no parks to select, but you still need to add your items to the event parks to make them available.",
  "Event park": "Event park | Event parks",
  "Owned park": "Owned park | Owned parks",
  "Applied automatically": "Applied automatically",
  "Not available for this event": "Not available for this event",
  "Event park automatically applied": "Event park automatically applied",
  "Model category": "Model category",
  "Product Name": "Product Name",
  "Year": "Year",
  "Models selected": "No model selected | 1 model selected | {count} models selected",
  "With item": "With item",
  "Stock": "Stock",
  "Tests": "Tests",
  "Reviews": "Reviews",
  "items_count": "No item | 1 item | {count} items",
  "reviews_nbr": "no reviews | 1 review | {count} reviews",
  "review": "review | review | reviews",
  "tests_count": "No test | 1 test | {count} tests",
  "park_count": "No park | 1 park | {count} parks",
  "Copy": "Copy",
  "Copied!": "Copied!",
  "Expiration": "Expiration",
  "Expiration date": "Expiration date",
  "References": "References",
  "Condition": "Condition",
  "Visibility": "Visivility",
  "Set public": "Set public",
  "Set private": "Set private",
  "Bulk actions:": "Bulk actions:",
  "Archive": "Archive",
  "Restore": "Restore",
  "Archived": "Archived",
  "Public": "Public",
  "Private": "Private",
  "Are you sure you want to perform this bulk action on the selected models?": "Are you sure you want to perform this bulk action on the selected models?",
  "Confirm": "Confirm",
  "Confirm my participation": "Confirm my participation",
  "Select the exhibitor you want to validate for this event": "Select the exhibitor you want to validate for this event",
  "Your participation to this event is not yet confirmed.": "Your participation to this event is not yet confirmed.",
  "Action required": "Action required",
  "Check in": "Check in",
  "Checked out at": "Checked out at",
  "Checked in at": "Checked in at",
  "Undo check-in": "Undo check-in",
  "Please select a context to configure the parks availability": "Please select a context to configure the parks availability",
  "Selected parks will be available for the entire event": "Selected parks will be available for the entire event",
  "Selected parks will be visible only on specific stage": "Selected parks will be visible only on specific stage",
  "Selected parks will be visible only on specific store": "Selected parks will be visible only on specific store",
  "Select all": "Select all",
  "Unselect all": "Unselect all",
  "Close": "Close",
  "Save": "Save",
  "Entire event": "Entire event",
  "Specific stage": "Specific stage",
  "Select a stage": "Select a stage",
  "Specific store": "Specific store",
  "Select a store": "Select a store",
  "Registration": "Registration",
  "Status": "Status",
  "Active": "Active",
  "Inactive": "Inactive",
  "No price": "No price",
  "Start date": "Start date",
  "End date": "End date",
  "Reset": "Reset",
  "Search": "Search",
  "Today": "Today",
  "Tomorrow": "Tomorrow",
  "After tomorrow": "After tomorrow",
  "Next 7 Days": "Next 7 Days",
  "Monday": "Monday",
  "Tuesday": "Tuesday",
  "Wednesday": "Wednesday",
  "Thursday": "Thursday",
  "Friday": "Friday",
  "Saturday": "Saturday",
  "Sunday": "Sunday",
  "Opening Hours": "Opening Hours",
  "Booking Slot Times": "Booking Slot Times",
  "Code": "Code",
  "Order": "Order",
  "Price": "Price",
  "Sale period": "Sale period",
  "Associated activity": "Associated activity",
  "variant": "no variant | 1 variant | {count} variants",
  "Email Address": "Email Address",
  "Phone": "Phone",
  "Birthdate": "Birthdate",
  "ProductTypes": "Product types",
  "Sizes": "Sizes",
  "Filter": "Filter",
  "Apply filters": "Apply filters",
  "Active filters": "Active filters",
  "This event is permanent": "This event is permanent",
  "If not please specify the dates.": "If not please specify the dates",
  "Timezone": "Timezone",
  "Select a date": "Select a date",
  "Free date": "Free date",
  "Select an existing Registration": "Select an existing registration",
  "Add a new Registration": "Add a new registration",
  "Registration deleted": "Registration deleted",
  "Payment method:": "Payment method:",
  "Add payment": "Add payment",
  "Confirm and authorize deposit": "Confirm and Authorize {amount} Deposit",
  "Saving deposit…": "Saving deposit…",
  "Thank you for providing the necessary information. We have confirmed the authorization on your bank account.": "Thank you for providing the necessary information. We have confirmed the authorization of {amount} on your bank account.",
  "Create Payment": "Create Payment",
  "Payment details": "Payment details",
  "Amount": "Amount",
  "Reference (optional):": "Reference (optional):",
  "Payment method": "Payment method",
  "Payments": "Payments",
  "Payment provider:": "Payment provider:",
  "Created at:": "Created at:",
  "Valid until:": "Valid until:",
  "Save payment": "Save payment",
  "Refresh": "Refresh",
  "Status:": "Status:",
  "Amount:": "Amount:",
  "Due amount:": "Due amount:",
  "Paid amount:": "Paid amount:",
  "Payment type:": "Payment type:",
  "Payment status:": "Payment status:",
  "Payment mode:": "Payment mode:",
  "Payment reference:": "Payment reference:",
  "Creation date:": "Creation date:",
  "Update date:": "Update date:",
  "Payment fee:": "Payment fee:",
  "Platform fee:": "Platform fee:",
  "Net amount:": "Net amount:",
  "View on Stripe": "View on Stripe",
  "Capturable amount:": "Capturable amount:",
  "Capture deposit": "Capture deposit",
  "Amount to capture": "Amount to capture",
  "Keep deposit": "Keep deposit",
  "Confirm deposit capture": "Confirm deposit capture",
  "Cancel deposit": "Cancel deposit",
  "Cancel payment": "Cancel payment",
  "Are you sure you want to cancel this deposit? This action cannot be undone.": "Are you sure you want to cancel this deposit? This action cannot be undone.",
  "Are you sure you want to cancel this payment? This action cannot be undone.": "Are you sure you want to cancel this payment? This action cannot be undone.",
  "Keep payment": "Keep payment",
  "Confirm deposit cancellation": "Confirm deposit cancellation",
  "Confirm payment cancellation": "Confirm payment cancellation",
  "Go to payment page": "Go to payment page",
  "Show QR Code": "Show QR Code",
  "Add filter": "Add filter",
  "Results per page": "Results per page",
  "Results {start}-{end} of {total}": "Results {start}-{end} of {total}",
  "Add": "Add",
  "Card:": "Card:",
  "Cancel": "Cancel",
  "Finish test": "Finish test",
  "Are you sure you want to finish the test?": "Are you sure you want to finish the test?",
  "Created at": "Created at",
  "Capture before": "Capture before",
  "Paid at": "Paid at",
  "Due Amount": "Due Amount",
  "Paid Amount": "Paid Amount",
  "result": "No result | 1 result | {count} results",
  "Tested on {date}": "Tested on {date}",
  "Search Brand": "Search Brand",
  "Star": "Star | Stars",
  "park selected": "No park selected | 1 park selected | {count} parks selected",
  "Add field": "Add field | Add fields",
  "Item deleted": "Item deleted",
  "Validate Attendee": "Validate Attendee",
  "Terms and Conditions": "Terms and Conditions",
  "No Barcode": "No Barcode",
  "Tester": "Tester",
  "Edit": "Edit",
  "Expected at": "Expected at",
  "Comment": "Comment",
  "Activity": "Activity",
  "Search by order number, name, or email address": "Search by order number, name, or email address",
  "Filters": "Filters",
  "Option value": "Option value",
  "Created after": "Created after",
  "Created before": "Created before",
  "Show deleted": "Show deleted",
  "Review": "Review",
  "Add Review": "Add Review",
  "You are not allowed to read this review": "You are not allowed to read this review",
  "Start test": "Start test",
  "Start a new test": "Start a new test",
  "The test started": "The test started",
  "Add comment": "Add comment",
  "(optional)": "(optional)",
  "Set expected return date": "Set expected return date",
  "Available Languages": "Available Languages",
  "Default language": "Default language",
  "Exponents": "Exponents",
  "Subscription": "Subscription",
  "Terms of use": "Terms of use",
  "Not accepted": "Not accepted",
  "Accepted": "Accepted",
  "Add Exponent": "Add Exponent",
  "Select an exponent": "Select an exponent",
  "Select exponent to add": "Select exponent to add",
  "As guest": "As guest",
  "Country": "Country",
  "Catalog": "Catalog",
  "Organizations": "Organizations",
  "Admin": "Admin",
  "My account": "My account",
  "Logout": "Logout",
  "Create Deposit for {name}": "Create Deposit for {name}",
  "Administrator": "Administrator",
  "number of participant": "1 participant | {nbr} participants",
  "Items selected": "No item selected | 1 item selected | {count} items selected",
  "Item(s) selected": "No item selected | 1 item selected | {count} items selected",
  "Delete item(s)": "Delete item | Delete items",
  "Are you sure you want to delete the selected item(s)?": "Are you sure you want to delete the selected item? | Are you sure you want to delete the selected items?",
  "Undo": "Undo",
  "Redo": "Redo",
  "Bold": "Bold",
  "Italic": "Italic",
  "Strikethrough": "Strikethrough",
  "Paragraph": "Paragraph",
  "Add a link": "Add a link",
  "Remove the link": "Remove the link",
  "Add an image": "Add an image",
  "Headings": "Headings",
  "Heading 2": "Heading 2",
  "Heading 3": "Heading 3",
  "Heading 4": "Heading 4",
  "Heading 5": "Heading 5",
  "Heading 6": "Heading 6",
  "Bullet list": "Bullet list",
  "Numbered list": "Numbered list",
  "Clear formatting": "Clear formatting",
  "Source code": "Source code",
  "Add member": "Add member",
  "Add a member": "Add a member",
  "Details": "Details",
  "Create a member": "Create a member",
  "Create the user account": "Create the user account",
  "Generate password": "Generate password",
  "Password must be 8 - 20 characters long.": "Password must be 8 - 20 characters long.",
  "Password": "Password",
  "Confirm Password": "Confirm Password",
  "First name": "First name",
  "Last name": "Last name",
  "Company": "Company",
  "Language": "Language",
  "Send information by email": "Send information by email",
  "Change": "Change",
  "Duration:": "Duration:",
  "Duration": "Duration",
  "Custom duration": "Custom duration",
  "equipment": "item",
  "registration": "registration",
  "Validate store": "Validate store",
  "Barcode": "Barcode",
  "Barcode updated": "Barcode updated",
  "Brand": "Brand",
  "Serial number": "Serial number",
  "Serial number:": "Serial number:",
  "Parks": "Parks",
  "Park": "Park",
  "Generate an automatic barcode": "Generate an automatic barcode",
  "Automatic barcode": "Automatic barcode",
  "Remove from other parks": "Remove from other parks",
  "Archive model": "Archive model",
  "Delete associated items": "Delete associated items",
  "View booking": "View booking",
  "Dates:": "Dates:",
  "Size:": "Size:",
  "Slot:": "Slot:",
  "Date": "Date",
  "Date:": "Date:",
  "Participant": "Participant",
  "No store selected": "No store selected",
  "No dates selected": "No dates selected",
  "No item selected": "No item selected",
  "No participant selected": "No participant selected",
  "Availability": "Availability",
  "View availability": "View availability",
  "The period is chosen at the date step and cannot be changed here.": "The period is chosen at the date step and cannot be changed here.",
  "The dates changed since this item was picked. Check it is still available.": "The dates changed since this item was picked. Check it is still available.",
  "Stage:": "Stage:",
  "Start at": "Start at",
  "End at": "End at",
  "Save dates": "Save dates",
  "Select Activity Variant(s)": "Select Activity Variant(s)",
  "Variants list": "Variants list",
  "Search for a location": "Search for a location",
  "Current position": "Current position",
  "If not please specify the dates": "If not please specify the dates",
  "Confirm my booking": "Confirm my booking",
  "Create a deposit request": "Create a deposit request",
  "Payment of the Security Deposit": "Payment of the Security Deposit",
  "Welcome to the Security Deposit page! We invite you to provide a deposit to validate your registration. Rest assured, this is simply a bank authorization.": "Welcome to the Security Deposit page! We invite you to provide a deposit to validate your registration. Rest assured, this is simply a bank authorization.",
  "No amount will be debited from your account.": "No amount will be debited from your account.",
  "This procedure allows us to verify that the funds are available.": "This procedure allows us to verify that the funds are available.",
  "At the end of the tests, the authorization will be automatically canceled, and the funds will be immediately available in your account again.": "At the end of the tests, the authorization will be automatically canceled, and the funds will be immediately available in your account again.",
  "Payment information": "Payment information",
  "Authorization Confirmation": "Authorization Confirmation",
  "Your security deposit has been successfully authorized!": "Your security deposit has been successfully authorized!",
  "Remember, no amount will be debited from your account at this stage.": "Remember, no amount will be debited from your account at this stage.",
  "Processing deposit…": "Processing deposit…",
  "Add activity": "Add activity",
  "Price:": "Price:",
  "Select a tax rate": "Select a tax rate",
  "rate": "rate",
  "Tax rate": "Tax rate",
  "Current sale price": "Current sale price",
  "Original Price": "Original Price",
  "If this price is set, it will appear as a “strikethrough price”. The “Current sale price” will always be applied in the cart.": "If this price is set, it will appear as a “strikethrough price”. The “Current sale price” will always be applied in the cart.",
  "Tax inc.": "Tax inc.",
  "No result ?": "No result ?",
  "Create new": "Create new",
  "Export to Excel format": "Export to Excel format",
  "Target not set": "Target not set",
  "Define the recipient criteria here": "Define the recipient criteria here",
  "Add new group": "Add new group",
  "Recipients": "Recipients",
  "Conditions Group": "Conditions Group",
  "Contacts must match all of the following conditions": "Contacts must match all of the following conditions",
  "Add new exhibitor": "Add new exhibitor",
  "Associate an exhibitor to this tour": "Associate an exhibitor to this tour",
  "Search for an exhibitor": "Search for an exhibitor",
  "Exhibitor or brand name": "Exhibitor or brand name",
  "Finish the configuration": "Finish the configuration",
  "Test no available": "Test no available",
  "You are not authorized to view this review": "You are not authorized to view this review",
  "Author:": "Author:",
  "Rating:": "Rating:",
  "Publish on a third-party service": "Publish on a third-party service",
  "Publishing on a third-party service": "Publishing on a third-party service",
  "Select a service": "Select a service",
  "Ready to buy it": "Ready to buy it",
  "Not ready to buy it": "Not ready to buy it",
  "Recommend to friends": "Recommend to friends",
  "Do not recommend to friends": "Do not recommend to friends",
  "Author": "Author",
  "Select a service to publish the selected reviews.": "Select a service to publish the selected reviews.",
  "{count} reviews selected": "No review selected | 1 review selected | {count} reviews selected",
  "{count} review(s) published successfully": "No reviews published | 1 review published successfully| {count} reviews published successfully",
  "Update status to “VALIDATED”": "Update status to “VALIDATED”",
  "Publish reviews": "Publish reviews",
  "new": "new",
  "validated": "validated",
  "rejected": "rejected",
  "After:": "After:",
  "Before:": "Before:",
  "Export": "Export",
  "New draw": "New draw",
  "In progress / Upcoming": "In progress / Upcoming",
  "Done / Archived": "Done / Archived",
  "Contacts": "Contacts",
  "booking": "Booking",
  "activity": "Activity",
  "payment": "Payment",
  "Duplicate": "Duplicate",
  "Manage variants": "Manage variants",
  "Duplicate with variants": "Duplicate with variants",
  "A new activity will be created with the same settings as the original.": "A new activity will be created with the same settings as the original.",
  "If checked, all variants and their options will also be duplicated.": "If checked, all variants and their options will also be duplicated.",
  "Add new field": "Add new field",
  "Select fields to add": "Select fields to add",
  "Required for registration validation": "Required for registration validation",
  "Remove": "Remove",
  "Display": "Display",
  "Display events": "Display events",
  "Hide": "Hide",
  "Hide events": "Hide events",
  "Required": "Required",
  "Download": "Download",
  "Sign here": "Sign here",
  "Yes": "Yes",
  "No": "No",
  "Select language": "Select language",
  "Translation filled in": "Translation filled in",
  "Translation missing": "Translation missing",
  "You must set up languages before setup custom fields": "You must set up languages before setup custom fields",
  "Choices not set": "Choices not set",
  "{count} choice(s)": "{count} choice(s)",
  "Search by reference, barcode or serial number": "Search by reference, barcode or serial number",
  "Search by model name, barcode number, serial number, or reference": "Search by model name, barcode number, serial number, or reference",
  "Search by name, email, company, phone number, or badge number": "Search by name, email, company, phone number, or badge number",
  "Filter by": "Filter by",
  "product": "product",
  "status": "status",
  "Test in progress?": "Test in progress?",
  "Total:": "Total:",
  "Expected return": "Expected return",
  "Sender’s Name": "Sender’s Name",
  "Reply-To Email Address": "Reply-To Email Address",
  "Email Options": "Email Options",
  "Header Image": "Header Image",
  "Footer Image": "Footer Image",
  "Email Subject": "Email Subject",
  "Email Message": "Email Message",
  "From file:": "From file:",
  "From date": "From date",
  "To date": "To date",
  "To date: {date}": "To date: {date}",
  "From date: {date}": "From date: {date}",
  "{fromDate} → {toDate}": "{fromDate} → {toDate}",
  "In progress": "In Progress",
  "Late": "Late",
  "Finished": "Finished",
  "Message": "Message",
  "Select a message": "Select a message",
  "Send": "Send",
  "Product test information": "Product test information",
  "Allotment": "Allotment",
  "Linked allotments modification": "Linked allotments modification",
  "The “Apply to linked allotments” option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.": "The “Apply to linked allotments” option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.",
  "Allotment information": "Allotment information",
  "Start": "Start",
  "End": "End",
  "Title": "Title",
  "Allow booking during this period": "Allow booking during this period",
  "Apply to linked allotments": "Apply to linked allotments",
  "Allotments": "Allotments",
  "Delete allotments": "Delete allotments",
  "Delete allotment": "Delete allotment",
  "Once you delete it, there is no going back. Please be certain.": "Once you delete it, there is no going back. Please be certain.",
  "Delete all allotments": "Delete all allotments",
  "Name (backoffice reference)": "Name (backoffice reference)",
  "Reference / SKU": "Reference / SKU",
  "Reference / SKU:": "Reference / SKU:",
  "Reference aliases": "Alternative references",
  "Add reference alias": "Add an alternative reference",
  "Delivery Channel": "Delivery Channel",
  "Email": "Email",
  "SMS": "SMS",
  "Sending Method": "Sending Method",
  "Manual": "Manual",
  "on demand": "on demand",
  "Scheduled": "Scheduled",
  "at a specific time": "at a specific time",
  "Deferred send type": "Deferred send type",
  "Sending date": "Sending date",
  "Stop sending after": "Stop sending after",
  "Automatic": "Automatic",
  "based on events": "based on events",
  "Trigger Event": "Trigger Event",
  "Time Offset from Trigger Event": "Time Offset from Trigger Event",
  "Offset can be negative or positive, 0 means immediate": "Offset can be negative or positive, 0 means immediate",
  "Message template": "Message template",
  "Select a template": "Select a template",
  "Maximum messages per recipient": "Maximum messages per recipient",
  "Unlimited": "Unlimited",
  "Leave empty for unlimited messages": "Leave empty for unlimited messages",
  "Country and Time Zone": "Country and Time Zone",
  "Event Dates": "Event Dates",
  "Condition Group": "Condition Group",
  "Conditions": "Conditions",
  "Behavior": "Behavior",
  "Add Condition": "Add Condition",
  "Add Condition Group": "Add Condition Group",
  "Give us your opinion": "Give us your opinion",
  "Thank you for your review!": "Thank you for your review!",
  "You can also review these products": "You can also review these products",
  "Access Type": "Access Type",
  "Permissions": "Permissions",
  "Remove member": "Remove member",
  "Are you sure?": "Are you sure?",
  "This action cannot be undone. This will permanently remove this member’s access.": "This action cannot be undone. This will permanently remove this member’s access.",
  "Delete": "Delete",
  "members": "members",
  "admin": "admin",
  "user": "user",
  "Edit Order Item": "Edit Order Item",
  "Add Order Item": "Add Order Item",
  "No registration selected": "No registration selected",
  "Quota:": "Quota:",
  "Used:": "Used:",
  "Remaining:": "Remaining:",
  "No limit": "No limit",
  "Add to order": "Add to order",
  "You don’t have enough participants for this activity, you need to add:": "You don’t have enough participants for this activity, you need to add:",
  "No variant selected": "No variant selected",
  "Scan QR Code": "Scan QR Code",
  "Select date": "Select date",
  "Select a registration": "Select a registration",
  "Search by name, email, phone number or badge number": "Search by name, email, phone number or badge number",
  "Value": "Value",
  "Label": "Label",
  "Add Option": "Add Option",
  "Options": "Options",
  "park(s)": "park | parks",
  "Search a location": "Search a location",
  "If this price is set, it will appear as a ": "If this price is set, it will appear as a ",
  "Select All": "Select All",
  "Unselect All": "Unselect All",
  "Minutes": "Minutes",
  "Hours": "Hours",
  "Days": "Days",
  "Select all items": "Select all items",
  "No slots configured for this stage.": "No slots configured for this stage.",
  "Slot setting": "Slot setting",
  "slot information": "slot information",
  "Configuration conflict!": "Configuration conflict!",
  "saving…": "saving…",
  "delete": "delete",
  "Add new slot": "Add new slot",
  "Add signature": "Add signature",
  "Delete signature": "Delete signature",
  "Signature": "Signature",
  "Apply": "Apply",
  "Update status to ": "Update status to ",
  "Add condition": "Add condition",
  "Configure {field}": "Configure {field}",
  "Choose where this field is asked and how it is answered.": "Choose where this field is asked and how it is answered.",
  "Done": "Done",
  "Extra": "Extra",
  "Validation": "Validation",
  "Registration custom fields": "Registration custom fields",
  "Auto-generated from the default locale translation": "Auto-generated from the default locale translation",
  "Edit option": "Edit option",
  "Confirm deletion": "Confirm deletion",
  "Are you sure you want to delete this option?": "Êtes-vous sûr de vouloir supprimer cette option ?",
  "Are you sure you want to delete this field?": "Êtes-vous sûr de vouloir supprimer ce champ ?",
  "This action cannot be undone.": "This action cannot be undone.",
  "You haven’t created custom fields yet.": "You haven’t created custom fields yet.",
  "Custom fields allow you to collect additional information during registration.": "Custom fields allow you to collect additional information during registration.",
  "Changes detected": "Changes detected",
  "To validate your modification, save the configuration at the bottom of the page": "To validate your modification, save the configuration at the bottom of the page",
  "Reference": "Reference",
  "(internal)": "(internal)",
  "Field type": "Field type",
  "Name": "Name",
  "Field label": "Field label",
  "Option label": "Option label",
  "(public)": "(public)",
  "Text": "Text",
  "Add new option": "Add new option",
  "Field configuration": "Field configuration",
  "Select variant(s)": "Select variant(s)",
  "Select Field": "Select Field",
  "Select Operation": "Select Operation",
  "Select Value": "Select Value",
  "Select Rule Type": "Select Rule Type",
  "Select position": "Select position",
  "Note:": "Note:",
  "Stripe dashboard:": "Stripe dashboard:",
  "Search by payment reference or registration name": "Search by payment reference or registration name",
  "Deposit QR Code": "Deposit QR Code",
  "Create deposit": "Create deposit",
  "Confirmation": "Confirmation",
  "Validate selection": "Validate selection",
  "Current price:": "Current price:",
  "Activity price:": "Activity price:",
  "Edit activity": "Edit activity",
  "loading…": "loading…",
  "You have too many participants for this activity, you need to remove:": "You have too many participants for this activity, you need to remove:",
  "no barcode": "no barcode",
  "has comment": "has comment",
  "The “Apply to linked allotments“ option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.": "The “Apply to linked allotments“ option is enabled by default; uncheck it if you do not wish to extend the modifications to the associated allotments.",
  "Select item": "Select item",
  "Select an item": "Select an item",
  "Create booking": "Create booking",
  "Searching…": "Searching…",
  "Notify members": "Notify members",
  "Distance": "Distance",
  "Show example": "Show example",
  "Dynamic content example": "Dynamic content example",
  "Field": "Field",
  "Value example": "Value example",
  "Dynamic content": "Dynamic content",
  "Sender": "Sender",
  "Select your date": "Select your date",
  "What’s new": "What’s new",
  "Notifications": "Notifications",
  "Processing…": "Processing…",
  "Process complete – The page will reload": "Process complete – The page will reload",
  "Member successfully added": "Member successfully added",
  "A new member has been added. Do you want to edit the permission for this member?": "A new member has been added. Do you want to edit the permission for this member?",
  "Later": "Later",
  "Edit permissions": "Edit permissions",
  "numberOfPermissions": "0 permission | 1 permission | {count} permissions",
  "User": "User",
  "Member": "Member",
  "Entity": "Entity",
  "Action": "Action",
  "Actions": "Actions",
  "Edit member": "Edit member",
  "Team Members": "Team Members",
  "Setup": "Setup",
  "Manage catalog": "Manage catalog",
  "Manage items": "Manage items",
  "Allows managing global settings for the exponent configuration.": "Allows managing global settings for the exponent configuration.",
  "Allows creating and editing models and items linked to the exponent.": "Allows creating and editing models and items linked to the exponent.",
  "Manage tours": "Manage tours",
  "Manage exponents": "Manage exponents",
  "Stripe accounts": "Stripe accounts",
  "Allows managing global settings for the organization.": "Allows managing global settings for the organization.",
  "Allows managing all tours within the organization.": "Allows managing all tours within the organization.",
  "Allows managing all exponents under the organization.": "Allows managing all exponents under the organization.",
  "Allows connecting and managing the organization’s Stripe accounts.": "Allows connecting and managing the organization’s Stripe accounts.",
  "Edit park": "Edit park",
  "Allows editing the park’s settings and details.": "Allows editing the park’s settings and details.",
  "Edit stage": "Edit stage",
  "Manage registrations": "Manage registrations",
  "Create product tests": "Create product tests",
  "Manage bookings": "Manage bookings",
  "Allows updating the stage settings and information.": "Allows updating the stage settings and information.",
  "Allows managing registrations associated with the stage.": "Allows managing registrations associated with the stage.",
  "Allows recording product tests during the stage.": "Allows recording product tests during the stage.",
  "Allows managing participant bookings for the stage.": "Allows managing participant bookings for the stage.",
  "Edit store": "Edit store",
  "Allows updating the store settings and information.": "Allows updating the store settings and information.",
  "Allows managing registrations associated with the store.": "Allows managing registrations associated with the store.",
  "Allows creating and recording product tests in the store.": "Allows creating and recording product tests in the store.",
  "Allows managing participant bookings for the store.": "Allows managing participant bookings for the store.",
  "Configure settings": "Configure settings",
  "View products": "View products",
  "Manage product tests": "Manage product tests",
  "View reviews": "View reviews",
  "View statistics": "View statistics",
  "Create marketing messages": "Create marketing messages",
  "Send marketing messages": "Send marketing messages",
  "Media Library": "Media Library",
  "No media found.": "No media found.",
  "Uploading…": "Uploading…",
  "{width} pixels width": "{width} pixels width",
  "Drop files here or click to upload.": "Drop files here or click to upload.",
  "Dynamic contents was successfully imported": "Dynamic contents was successfully imported",
  "Dynamic contents was successfully removed": "Dynamic contents was successfully removed",
  "Import": "Import",
  "Delete the image": "Delete the image",
  "View bookings": "View bookings",
  "View orders": "View orders",
  "Update orders": "Update orders",
  "View payments": "View payments",
  "Update payments": "Update payments",
  "Allows configuring the general settings of the event.": "Allows configuring the general settings of the event.",
  "Allows managing participant registrations for the event.": "Allows managing participant registrations for the event.",
  "Allows viewing products linked to the event.": "Allows viewing products linked to the event.",
  "Allows managing product tests during the event.": "Allows managing product tests during the event.",
  "Allows viewing products reviews.": "Allows viewing products reviews.",
  "Allows viewing event statistics.": "Allows viewing event statistics.",
  "Allows creating marketing messages for the event.": "Allows creating marketing messages for the event.",
  "Allows sending marketing messages to participants.": "Allows sending marketing messages to participants.",
  "Allows managing participant bookings for the event.": "Allows managing participant bookings for the event.",
  "Allows viewing bookings for the event in read-only.": "Allows viewing bookings for the event in read-only.",
  "Allows viewing orders related to the event.": "Allows viewing orders related to the event.",
  "Allows updating existing orders for the event.": "Allows updating existing orders for the event.",
  "Allows viewing payment information for the event.": "Allows viewing payment information for the event.",
  "Allows updating and managing event payments.": "Allows updating and managing event payments.",
  "Add an item": "Add an item",
  "Filter type": "Filter type",
  "Filter value": "Filter value",
  "Edit filter": "Edit filter",
  "Remove filter": "Remove filter",
  "Filter by {type}": "Filter by {type}",
  "{firstLabel} and {count} more": "{firstLabel} and {count} more",
  "{labels} · {toggle}: {state}": "{labels} · {toggle}: {state}",
  "Remove all filters": "Remove all filters",
  "Filter values": "Filter values",
  "User not found": "User not found",
  "No user account found for this email. Please create one to add the user as a team member.": "No user account found for this email. Please create one to add the user as a team member.",
  "Create a user account": "Create a user account",
  "Create user & add member": "Create user & add member",
  "No result": "No result",
  "No items found matching your search or filters.": "No items found matching your search or filters.",
  "No {modelName} found": "No {modelName} found",
  "No {modelName} found matching your search or filters.": "No {modelName} found matching your search or filters.",
  "Create new {modelName}": "Create new {modelName}",
  "activities": "No activity | 1 activity | {count} activities",
  "Set date": "Set date",
  "No comment": "No comment",
  "Enter your comment here…": "Enter your comment here…",
  "Overall Rating": "Overall Rating",
  "Review title": "Review title",
  "Summarize your impression on the product": "Summarize your impression on the product",
  "Your detailed product review": "Your detailed product review",
  "50 characters minimum": "50 characters minimum",
  "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?": "What was your impression of the product while testing? What did you like or dislike about the product? What conditions where present while testing the product?",
  "50 characters (minimum)": "50 characters (minimum)",
  "Comments": "Comments",
  "Comments on the reception, the organization, the advice on the product…": "Comments on the reception, the organization, the advice on the product…",
  "Would you recommend this product to a friend?": "Would you recommend this product to a friend?",
  "Would you be ready to buy this product?": "Would you be ready to buy this product?",
  "First name or pseudo": "First name or pseudo",
  "Your name / nickname is published with your review": "Your name / nickname is published with your review",
  "I have read and I accept the terms and conditions": "I have read and I accept the terms and conditions",
  "of publication of the reviews": "of publication of the reviews",
  "and": "and",
  "the privacy policy": "the privacy policy",
  "Post Review": "Post Review",
  "Very bad": "Very bad",
  "Bad": "Bad",
  "Average": "Average",
  "Good": "Good",
  "Great!": "Great!",
  "Image caption": "Image caption",
  "Loading product test…": "Loading product test…",
  "Expected return date": "Expected return date",
  "This will permanently delete this allotment and all linked allotments. This action cannot be undone.": "This will permanently delete this allotment and all linked allotments. This action cannot be undone.",
  "This will permanently delete this allotment. This action cannot be undone.": "This will permanently delete this allotment. This action cannot be undone.",
  "Message sent successfully.": "Message sent successfully.",
  "Quota": "Quota",
  "Sales start at": "Sales start at",
  "Sales end at": "Sales end at",
  "Variant Edit": "Variant Edit",
  "Variant": "Variant",
  "Associated stages": "Associated stages",
  "Associated stages/dates": "Associated stages/dates",
  "Select one or more stages that participants will automatically be associated to when ordering this variant.": "Select one or more stages that participants will automatically be associated to when ordering this variant.",
  "optional": "optional",
  "Type": "Type",
  "Create deposit batch": "Create deposit batch",
  "All activities": "All activities",
  "Create": "Create",
  "Started at": "Started at",
  "Completed at": "Completed at",
  "Outcome state": "Outcome state",
  "Performed by": "Performed by",
  "Create new record": "Create new record",
  "Edit maintenance record": "Edit maintenance record",
  "Create maintenance record": "Create maintenance record",
  "Select a type": "Select a type",
  "Subtype": "Subtype",
  "Short description of the intervention": "Short description of the intervention",
  "Select a status": "Select a status",
  "Item condition": "Item condition",
  "Select a condition": "Select a condition",
  "Next check at": "Next check at",
  "Time spent (minutes)": "Time spent (minutes)",
  "Duration in minutes": "Duration in minutes",
  "Cost": "Cost",
  "Currency": "Currency",
  "Select a currency": "Select a currency",
  "Notes": "Notes",
  "Additional details about the maintenance...": "Additional details about the maintenance...",
  "Saving…": "Saving…",
  "Update": "Update",
  "An error occurred while saving the maintenance record": "An error occurred while saving the maintenance record",
  "Add maintenance record": "Add maintenance record",
  "No maintenance records found": "No maintenance records found",
  "View": "View",
  "Successfully subscribed to notifications": "Successfully subscribed to notifications",
  "Successfully unsubscribed from notifications": "Successfully unsubscribed from notifications",
  "Failed to update notification subscription": "Failed to update notification subscription",
  "What do you want to import ?": "What do you want to import?",
  "Update only": "Update only",
  "If checked, only existing models/items will be updated, new ones will be ignored": "If checked, only existing models/items will be updated, new ones will be ignored",
  "How do you want to identify your models or items?": "How do you want to identify your models or items?",
  "The Identifier determines how models or items are uniquely matched:": "The Identifier determines how models or items are uniquely matched:",
  "Model Reference: ensures models are unique to a brand using their reference.": "Model Reference: ensures models are unique to a brand using their reference.",
  "Model Name: checks uniqueness based on the model name.": "Model Name: checks uniqueness based on the model name.",
  "QR Code: ensures each item is unique using its QR code.": "QR Code: ensures each item is unique using its QR code.",
  "This setup helps the system efficiently update existing items or associate them with the correct model.": "This setup helps the system efficiently update existing items or associate them with the correct model.",
  "Example: A model with the reference ‘ABC123’ and name ‘Ski Boots X’ can be matched using either Model Reference or Model Name, depending on your file structure.": "Example: A model with the reference ‘ABC123’ and name ‘Ski Boots X’ can be matched using either Model Reference or Model Name, depending on your file structure.",
  "Duplicate Identifiers in your file will be ignored during import to prevent conflicts.": "Duplicate Identifiers in your file will be ignored during import to prevent conflicts.",
  "Make sure each item in your file has a unique Identifier to ensure accurate matching and updates.": "Make sure each item in your file has a unique Identifier to ensure accurate matching and updates.",
  "Select the columns corresponding to the fields": "Select the columns corresponding to the fields",
  "Match the fields with the columns of the file.": "Match the fields with the columns of the file.",
  "If a field is not matched, it will not be imported/updated.": "If a field is not matched, it will not be imported/updated.",
  "Model information": "Model information",
  "Item information": "Item information",
  "Auto Generated Barcode": "Auto Generated Barcode",
  "If no column is selected for Barcode / QR Code, barcodes will be autogenerated for each item.": "If no column is selected for Barcode / QR Code, barcodes will be autogenerated for each item.",
  "Add items to park": "Add items to park",
  "Add items to {target}": "Add items to {target}",
  "Add to inventory": "Add to inventory",
  "Add to park": "Add to park",
  "inventory": "inventory",
  "Important:": "Important:",
  "Save all quotas": "Save all quotas",
  "Total quota": "Total quota",
  "Assign to another model": "Assign to another model",
  "Associated tests will be moved.": "Associated tests will be moved.",
  "Linked reviews and ratings will also be transferred.": "Linked reviews and ratings will also be transferred.",
  "Select a model": "Select a model",
  "History": "History",
  "Delete this item": "Delete this item",
  "Delete this model": "Delete this model",
  "Delete this question": "Delete this question",
  "Delete this brand": "Delete this brand",
  "Delete this exponent": "Delete this exponent",
  "Delete this template": "Delete this template",
  "Delete this park": "Delete this park",
  "Delete this metafield": "Delete this metafield",
  "Delete this registration": "Delete this registration",
  "Delete this registration (GDPR request)": "Delete this registration (GDPR request)",
  "Delete this review": "Delete this review",
  "Delete this activity": "Delete this activity",
  "Delete this option": "Delete this option",
  "Delete this value": "Delete this value",
  "Delete this promotion": "Delete this promotion",
  "Delete this registration form": "Delete this registration form",
  "Delete this stage": "Delete this stage",
  "Delete this stand layout": "Delete this stand layout",
  "Delete this tax rate": "Delete this tax rate",
  "Delete this third party service": "Delete this third party service",
  "{historyType} for {userLink}": "{historyType} for {userLink}",
  "Product test": "Product test",
  "Ongoing": "On going",
  "Upcoming": "Upcoming",
  "Ended": "Ended",
  "Description": "Description",
  "Stages": "Stages",
  "Tags": "Tags",
  "Tests count": "Tests count",
  "Previous": "Previous",
  "Next": "Next",
  "Booking dates": "Booking dates",
  "Unsupported filter type: {type}": "Unsupported filter type: {type}",
  "Product Test": "Product Test",
  "Associated members to notify": "Associated members to notify",
  "Resend invitation": "Resend invitation",
  "Send invitation": "Send invitation",
  "Item status": "Item status",
  "Item health state": "Item health state",
  "number of SMS": "{length} characters · {encoding} · {segments} SMS",
  "You must accept the terms of use to continue.": "You must accept the terms of use to continue.",
  "Published on {date}": "Published on {date}",
  "I accept the terms of use": "I accept the terms of use",
  "Saving...": "Saving...",
  "Install": "Install",
  "Change URL": "Change URL",
  "Change the event URL": "Change the event URL",
  "New URL": "New URL",
  "Update slug": "Update slug",
  "Add parameter": "Add parameter",
  "Order Details": "Order Details",
  "Quantity": "Quantity",
  "Will be rounded up to": "Will be rounded up to",
  "barcodes": "barcodes",
  "Delivery Address": "Delivery Address",
  "Company Name": "Company Name",
  "Recipient Name": "Recipient Name",
  "Search Address": "Search Address",
  "Full Address": "Full Address",
  "Order Barcode Labels": "Order Barcode Labels",
  "Barcode orders": "Barcode orders",
  "Exponent": "Exponent",
  "Step 1 — Configure filters": "Step 1 — Configure filters",
  "Refine the data range to include in your export.": "Refine the data range to include in your export.",
  "Step 2 — Download the export": "Step 2 — Download the export",
  "You will receive an email when the file is ready.": "You will receive an email when the file is ready.",
  "Error": "Error",
  "Stop editing": "Stop editing",
  "Edit barcodes": "Edit barcodes",
  "Select": "Select",
  "No user account found for this email.": "No user account found for this email.",
  "Order on behalf of": "Order on behalf of",
  "Search by name or email...": "Search by name or email...",
  "Leave empty to create the order for yourself.": "Leave empty to create the order for yourself.",
  "Delete this payment provider": "Delete this payment provider",
  "Delete this inventory": "Delete this inventory",
  "Delete this variant": "Delete this variant",
  "Type {text} to confirm": "Type {text} to confirm",
  "Close inventory": "Close inventory",
  "Are you sure you want to close this inventory? This action cannot be undone.": "Are you sure you want to close this inventory? This action cannot be undone.",
  "Are you sure you want to archive this inventory?": "Are you sure you want to archive this inventory?",
  "Delete all barcodes": "Delete all barcodes",
  "Delete all barcodes of the registrations to reuse them on another event.": "Delete all barcodes of the registrations to reuse them on another event.",
  "This action cannot be undone. All barcodes of the participants will be deleted.": "This action cannot be undone. All barcodes of the participants will be deleted.",
  "Restore product": "Restore product",
  "Restored products can be used again": "Restored products can be used again",
  "Restore this product": "Restore this product",
  "Delete all permissions": "Delete all permissions",
  "This permanently erases the registrant's personal data to satisfy a GDPR request. This action is irreversible.": "This permanently erases the registrant’s personal data to satisfy a GDPR request. This action is irreversible.",
  "Delete all proof of identities": "Delete all proof of identities",
  "Permanently delete every proof of identity file for the concerned registrations.": "Permanently delete every proof of identity file for the concerned registrations.",
  "This permanently deletes all proof of identity files. This action is immediate and cannot be undone.": "This permanently deletes all proof of identity files. This action is immediate and cannot be undone.",
  "Delete proof of identities": "Delete proof of identities",
  "Delete all avatars": "Delete all avatars",
  "Permanently delete the avatar of the concerned registrations.": "Permanently delete the avatar of the concerned registrations.",
  "This permanently deletes all registration avatars. This action is immediate and cannot be undone.": "This permanently deletes all registration avatars. This action is immediate and cannot be undone.",
  "Delete avatars": "Delete avatars",
  "Anonymize all registrations": "Anonymize all registrations",
  "Permanently replace personal data on the concerned registrations. Records are kept but anonymized.": "Permanently replace personal data on the concerned registrations. Records are kept but anonymized.",
  "This permanently anonymizes all registrations (personal data is replaced). This action is immediate and cannot be undone.": "This permanently anonymizes all registrations (personal data is replaced). This action is immediate and cannot be undone.",
  "Anonymize registrations": "Anonymize registrations",
  "Anonymize": "Anonymize",
  "This field requires {field}": "This field requires {field}",
  "{field} must also be displayed in: {contexts}": "{field} must also be displayed in: {contexts}",
  "Apply a rule to this field": "Apply a rule to this field",
  "Add a field that can drive a rule to the form first": "Add a field that can drive a rule to the form first",
  "only when all of:": "only when all of:",
  "Add a condition": "Add a condition",
  "Remove this condition": "Remove this condition",
  "Effect": "Effect",
  "Age in years": "Age in years",
  "Where this field appears": "Where this field appears",
  "Hidden": "Hidden",
  "Optional": "Optional",
  "Required to validate": "Required to validate",
  "Required for a registration to be validated": "Required for a registration to be validated",
  "Conditional": "Conditional",
  "Reorder": "Reorder",
  "Online form": "Online form",
  "Mobile app": "Mobile app",
  "Export the orders": "Export the orders",
  "Export the order items": "Export the order items",
  "The export could not be started.": "The export could not be started.",
  "Order number": "Order number",
  "Customer name": "Customer name",
  "No customer": "No customer",
  "Deleted": "Deleted",
  "Total Amount:": "Total Amount:",
  "Participants": "Participants",
  "+ {count} more": "+ {count} more",
  "Order #": "Order #",
  "IP address": "IP address",
  "Device": "Device",
  "Session": "Session",
  "Suspicious": "Suspicious",
  "Deleted user": "Deleted user",
  "Successful": "Successful",
  "Failed": "Failed",
  "Unknown": "Unknown",
  "Signed out at {time}": "Signed out at {time}",
  "Search by user or IP address": "Search by user or IP address",
  "Stock location": "Stock location",
  "Batch": "Batch",
  "Select a batch": "Select a batch",
  "{count} available": "{count} available",
  "No available barcodes in this location": "No available barcodes in this location",
  "Header name": "Header name",
  "Header value": "Header value",
  "Unchanged": "Unchanged",
  "Add a header": "Add a header",
  "This site is protected by reCAPTCHA.": "This site is protected by reCAPTCHA.",
  "Google Privacy Policy": "Google Privacy Policy",
  "Google Terms of Service": "Google Terms of Service",
};
